import {useContext} from 'react'
import {OrgCustomizationContext} from "../themes/OrgCustomizationProvider";

const useDefaultRadioOptions = () => {
    const {t} = useContext(OrgCustomizationContext)

    return {
        yesNoRadioOptions: [
            {value: 'YES', label: t('option_yes')},
            {value: 'NO', label: t('option_no')},
        ]
    }
}

export default useDefaultRadioOptions
